import { StyleSheet } from 'aphrodite';
import { destructive, header, mention } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {},
	error: {
		color: destructive,
	},
	gray: {
		color: header,
		fontSize: 14,
		paddingTop: 15,
	},
	header: {
		fontSize: 18,
		padding: '20px 0 5px',
	},
	multiplePhoneNumbersSelect: {
		marginTop: 10,
		minWidth: 230,
		backgroundColor: 'white',
	},
	multiplePhoneNumbersSelectContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		minHeight: '100%',
	},
	noValidPhoneOptionsIcon: {
		marginTop: 2,
	},
	selectContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
	},
	textingGraphicContainer: {
		alignItems: 'center',
		background: mention,
		borderRadius: '50%',
		display: 'flex',
		height: 180,
		justifyContent: 'center',
		width: 180,
	},
	useThisNumberCta: {
		marginTop: 20,
	},
});
